<template>
  <div
    class="inline-flex w-18 items-stretch space-x-1 rounded-5 border border-gray-200/80 bg-white p-0.5"
  >
    <template v-for="(position, index) in POSITIONS" :key="position">
      <button
        type="button"
        :class="[
          'group flex items-center justify-center rounded-5 p-2 transition-all duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 focus-visible:ring-offset-white',
          disabled ? 'cursor-not-allowed opacity-50' : '',
          modelValue === position
            ? 'scale-100 bg-blue-100 text-blue-600 shadow-sm'
            : disabled
              ? 'text-gray-400'
              : 'text-gray-500 hover:bg-gray-100 hover:text-gray-700 active:bg-gray-200',
        ]"
        :disabled="disabled"
        @click="updatePosition(position)"
      >
        <icon-base
          :icon="POSITION_ICONS[position]"
          :class="[
            'h-3 w-3 transition-transform duration-150 ease-in-out',
            modelValue === position
              ? ''
              : 'group-hover:scale-105 group-active:scale-95',
          ]"
        />
      </button>
      <div
        v-if="index < POSITIONS.length - 1"
        class="mx-0.5 h-6 self-center border-l border-gray-200"
      ></div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { BlockAlignment } from "@/models/borrowerPlatformTemplates";

import IconTextAlignCenter from "@/components/icons/borrowerPlatform/borrowerTabs/IconTextAlignCenter.vue";
import IconTextAlignLeft from "@/components/icons/borrowerPlatform/borrowerTabs/IconTextAlignLeft.vue";
import IconBase from "@/components/ui/IconBase.vue";

const { disabled = false } = defineProps<{
  disabled?: boolean;
}>();

const modelValue = defineModel<BlockAlignment>();

const POSITION_ICONS = {
  [BlockAlignment.LEFT]: IconTextAlignLeft,
  [BlockAlignment.CENTER]: IconTextAlignCenter,
};

const POSITIONS = [BlockAlignment.LEFT, BlockAlignment.CENTER];

const updatePosition = (position: BlockAlignment) => {
  if (disabled) {
    return;
  }
  modelValue.value = position;
};
</script>
